// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-top-navigation-menu-item_container__s83t1"};